import {Column, FlexGrid, Heading, Row} from "@carbon/react";
import Profile from "../../components/Profile";
import { useTranslation } from "react-i18next";

const ProfileLayout = () => {
    const { t } = useTranslation();
    return (
        <div className="page-container">
            <FlexGrid narrow={true}>
                <Column>
                    <Row>
                        <Heading className="">{t("profile.title")}</Heading>
                    </Row>
                    <Row>
                        <Profile></Profile>
                    </Row>
                </Column>
            </FlexGrid>
        </div>
    )
}
export default ProfileLayout
